// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeviceDetails__header-c09cb9 {
  margin: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.DeviceDetails__device-icon-container-eaa0ef {
  margin-bottom: 16px;
  position: relative;
}

.DeviceDetails__header-icon-f70f65 {
  background-color: var(--brand-primary-40);
  padding: 16px;
  border-radius: 50%;
  fill: var(--addition-50);
}

.DeviceDetails__device-name-c096a8 {
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-8);
  color: var(--base-110);
}

.DeviceDetails__last-activity-ffed95 {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
}

.DeviceDetails__badge-icon-f53316 {
  background-color: var(--base-0);
  fill: var(--base-80);
  padding: 4px;
  position: absolute;
  bottom: -3px;
  right: -3px;
  border-radius: 50%;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Device/DeviceDetails/DeviceDetails.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,kBAAA;AACF;;AAEA;EACE,yCAAA;EACA,aAAA;EACA,kBAAA;EACA,wBAAA;AACF;;AAEA;EACE,yBAAA;EACA,2CAAA;EACA,sBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;AACF;;AAEA;EACE,+BAAA;EACA,oBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AACF","sourcesContent":[".header {\n  margin: 24px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.device-icon-container {\n  margin-bottom: 16px;\n  position: relative;\n}\n\n.header-icon {\n  background-color: var(--brand-primary-40);\n  padding: 16px;\n  border-radius: 50%;\n  fill: var(--addition-50);\n}\n\n.device-name {\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-8);\n  color: var(--base-110);\n}\n\n.last-activity {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n}\n\n.badge-icon {\n  background-color: var(--base-0);\n  fill: var(--base-80);\n  padding: 4px;\n  position: absolute;\n  bottom: -3px;\n  right: -3px;\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `DeviceDetails__header-c09cb9`,
	"device-icon-container": `DeviceDetails__device-icon-container-eaa0ef`,
	"deviceIconContainer": `DeviceDetails__device-icon-container-eaa0ef`,
	"header-icon": `DeviceDetails__header-icon-f70f65`,
	"headerIcon": `DeviceDetails__header-icon-f70f65`,
	"device-name": `DeviceDetails__device-name-c096a8`,
	"deviceName": `DeviceDetails__device-name-c096a8`,
	"last-activity": `DeviceDetails__last-activity-ffed95`,
	"lastActivity": `DeviceDetails__last-activity-ffed95`,
	"badge-icon": `DeviceDetails__badge-icon-f53316`,
	"badgeIcon": `DeviceDetails__badge-icon-f53316`
};
module.exports = ___CSS_LOADER_EXPORT___;
